/**
 * settings — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { settings as de_settings } from '../de/settings';

export const settings: Record<keyof typeof de_settings, string> = {

  /* ---------------- password: forgotten, reset, changed ---------------- */
  'pw.forgot.link': 'Forgot your password?',
  'pw.forgot.title': 'Reset your password',
  'pw.forgot.lead':
    'We send a link to the account’s email address. It is valid for 60 minutes and can be used once.',
  'pw.forgot.send': 'Send the link',
  'pw.forgot.sent': 'If an account exists, we have sent a link.',
  'pw.forgot.sent.hint':
    'The mail arrives within a few minutes — please check the spam folder too. At most three links per hour and account.',
  'pw.reset.title': 'Set a new password',
  'pw.reset.lead':
    'This signs out every device, including this one. Sign in again with the new password afterwards.',
  'pw.reset.save': 'Set the password',
  'pw.reset.again': 'Request a new link',
  'pw.reset.notoken': 'This link is incomplete — it carries no token. Please request a new one.',
  'pw.reset.done': 'Password changed. Please sign in with the new password.',
  'pw.tologin': 'To the sign-in page',
  'pw.change': 'Change password',
  'pw.change.lead': 'This device stays signed in; every other device is signed out.',
  'pw.current': 'Current password',
  'pw.new': 'New password',
  'pw.repeat': 'Repeat the new password',
  'pw.rule': '(at least {n} characters)',
  'pw.save': 'Save the password',
  'pw.cancel': 'Cancel',
  'pw.changed': 'Password changed.',
  'pw.err.short': 'The new password is too short — at least {n} characters.',
  'pw.err.mismatch': 'The two passwords do not match.',
  'pw.err.current': 'The current password is not correct.',
  'pw.err.email': 'Please enter a valid email address.',

  /* ---------------- Settings ---------------- */
  'settings.title': 'Settings',
  'settings.appearance': 'Appearance',
  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.account': 'Account',
  'settings.signedout': 'Sign in to save flights.',
};
